/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
import { useTheme } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import ArrowDown from "../../../../public/assets/icons/ArrowDown";
import { TTheme } from "../../../utils/configs/setupTheme";
import { ACCESS_LEVEL } from "../utils/contants";
import SubjectTypeCard from "./SubjectTypeCard";
import { ITEMS_PER_PAGE, TOPIC_OPENING_VIEW_TYPE_TAB } from "../../common/utils/constant";
import CustomPagination from "../../common/components/Pagination";
import { subjectActions } from "../redux/actions";
import { TTopicCardData } from "../utils/type";
import { isEmpty } from "../../../utils/constants/constants";
import { TCommonState } from "../../common/utils/type";

interface IProps {
  handleClickLink: (url: string, price?: number, isConfirm?: boolean) => void;
  list: TTopicCardData;
  checkIsHideItem: (num: number) => boolean;
  location: any;
  isShowLock: (accessLevel: number) => boolean;
  handleOpenModalConfirmLogin: (accessLevel) => void;
  handleOpenModalConfirmPremium: (accessLevel) => void;
  handleOpenModalReport: (ele) => void;
  pageCurrent: number;
  fetchTopics: (page) => void;
  handleSetLoading: () => void;
}
const SubjectTabCard = ({
  handleClickLink,
  list,
  checkIsHideItem,
  location,
  isShowLock,
  handleOpenModalConfirmLogin,
  handleOpenModalConfirmPremium,
  handleOpenModalReport,
  handleSetLoading,
  pageCurrent,
  fetchTopics
}: IProps) => {
  const dataUser = useSelector((state: { commonNew: TCommonState }) => state.commonNew.userInfos);
  const theme: TTheme = useTheme();
  const dispatch = useDispatch();
  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    dispatch(subjectActions.handleChoosePage(newPage));
    handleSetLoading();
    fetchTopics(newPage - 1);
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 20, behavior: "smooth" });
    }
  };
  return (
    <div className="h-max pb-4">
      {list?.items.map((element, index) => (
        <div key={index}>
          {list?.items?.length > 1 && (
            <button
              type="button"
              style={{
                color: "black",
                padding: 0,
                display: "flex",
                justifyContent: "space-between",
                width: "100%"
              }}
            >
              <span className="normal-case font-semibold text-[18px]" style={{ textAlign: "justify" }}>
                {element?.title}
              </span>
              <div
                style={{
                  color: theme.palette.primary.gray400,
                  transform: !checkIsHideItem(index) ? "rotate(-90deg)" : ""
                }}
              >
                <ArrowDown />
              </div>
            </button>
          )}
          <div className="flex flex-row flex-wrap justify-between items-center gap-x-4">
            {!checkIsHideItem(index) &&
              element.items?.slice(0, ITEMS_PER_PAGE)?.map((ele, idx) => (
                <button
                  type="button"
                  key={idx}
                  style={{
                    cursor: "pointer",
                    color: "black"
                  }}
                  className="py-3 min-h-[106px] sm:w-[92vw] md:min-w-[296px] 2xl:w-[48%]"
                  onClick={() => {
                    if (typeof dataUser?.member?.pub_id !== "undefined") {
                      if (ACCESS_LEVEL.PREMIUM.includes(ele?.access_level) && !isShowLock(ele?.access_level)) {
                        return handleOpenModalConfirmPremium(ele?.access_level);
                      }
                      if (ele?.access_level === ACCESS_LEVEL.LOGIN && !isShowLock(ele?.access_level)) {
                        return handleOpenModalConfirmLogin(ele?.access_level);
                      }
                      return handleClickLink(
                        `/${location?.grade}/${location?.subjectsId}/${
                          list?.type === "practice"
                            ? TOPIC_OPENING_VIEW_TYPE_TAB.PRACTICE
                            : list.type === "card"
                            ? TOPIC_OPENING_VIEW_TYPE_TAB.CARD
                            : TOPIC_OPENING_VIEW_TYPE_TAB.EXAMS
                        }/${ele?.slug}`,
                        ele?.access_level === ACCESS_LEVEL.NOT_LOGIN ? 0 : ele?.extra?.price,
                        list?.type === "exam" && !ele?.num_of_times
                      );
                    }
                    if (!isShowLock(ele?.access_level)) {
                      return handleOpenModalConfirmLogin(ele?.access_level);
                    }
                    return handleClickLink(
                      `/${location?.grade}/${location?.subjectsId}/${
                        list?.type === "practice"
                          ? TOPIC_OPENING_VIEW_TYPE_TAB.PRACTICE
                          : list.type === "card"
                          ? TOPIC_OPENING_VIEW_TYPE_TAB.CARD
                          : TOPIC_OPENING_VIEW_TYPE_TAB.EXAMS
                      }/${ele?.slug}`,
                      ele?.access_level === ACCESS_LEVEL.NOT_LOGIN ? 0 : ele?.extra?.price,
                      list?.type === "exam" && !ele?.num_of_times
                    );
                  }}
                >
                  <SubjectTypeCard ele={ele} isShowLock={isShowLock} handleOpenModalReport={handleOpenModalReport} />
                </button>
              ))}
          </div>
          <div className="flex flex-row-reverse">
            <CustomPagination
              pageTotal={element?.total_page as number}
              page={pageCurrent === 0 ? 1 : pageCurrent}
              handleChoosePage={handleChangePage}
              disabled={isEmpty(element?.total_page)}
            />
          </div>
        </div>
      ))}
    </div>
  );
};
export default SubjectTabCard;
